import { getCustomer } from "@/graphql/schemas/shared/utils/getCustomer"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { getCountryFromLocale } from "../../shared/utils/getCountryFromLocale"
import { getSkuPrice } from "../../shared/utils/getPrices"
import { getStoreKeysWithChannels } from "../../shared/utils/getStoreKeysWithChannels"

export const queryCustomerSkuPrice = {
  async skuCustomerPrice(parent, args, context, info) {
    const { customerId, sku, locale, customerNumber } = args
    const { user } = context

    const customer = await getCustomer({ id: customerId, number: customerNumber })
    const channels = await getStoreKeysWithChannels(customer?.stores)

    await Promise.all([
      checkPermissions({
        user,
        domainObject: DomainObjects.PRICES,
        operation: Operations.READ,
      }),
      validateAccessRightsToCustomer({
        user,
        customerNumber: customer.customerNumber,
      }),
    ])

    // to cover the case when country is sent like this: "de-DE"
    const extractedCountry = getCountryFromLocale(locale)
    const price = await getSkuPrice({
      sku,
      channels,
      group: customer.customerGroup,
      country: extractedCountry,
    })

    return price || null
  },
}
